class DcbFilters extends HTMLElement {
  connectedCallback() {
    // The section script can run before this element's children are parsed,
    // which would leave every querySelector null and no listeners attached.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
    } else {
      this.init();
    }
  }

  init() {
    const scope = this.closest('.dcb-page')?.querySelector('[data-filter-scope]');
    if (!scope) return;
    this.querySelectorAll('[data-filter-btn]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const filter = btn.getAttribute('data-filter-btn');
        this.querySelectorAll('[data-filter-btn]').forEach((b) => b.classList.toggle('is-active', b === btn));
        scope.querySelectorAll('[data-filter-item]').forEach((item) => {
          item.hidden = filter !== 'all' && item.getAttribute('data-category') !== filter;
        });
      });
    });
  }
}
customElements.define('dcb-filters', DcbFilters);
